module.exports = __webpack_public_path__ + "media/images/icons/facebook-e117cff9e865ae5783e39fbe81938bd4.svg";